/**
 * Created by Viacheslav Stepanian on 16.04.2026
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ISLAND_DECORATION_TITLE: {
        size: 80,
        color: cleverapps.styles.COLORS.COINS_REWARD_YELLOW,
        stroke: cleverapps.styles.DECORATORS.BROWN_STROKE
    },

    ISLAND_DECORATION_STAGE_TITLE: {
        size: 28,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    ISLAND_DECORATION_STAGE_REWARDS: {
        size: 36,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    ISLAND_DECORATION_ITEM_TITLE: {
        name: "nostroke",
        size: 36,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    ISLAND_DECORATION_ITEM_PRICE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    ISLAND_DECORATION_TIMER: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    ISLAND_DECORATION_PROGRESSBAR: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    ISLAND_PREVIEW_TITLE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW
    },

    ISLAND_PREVIEW_TITLE_DESCRIPTION: {
        size: 32,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW
    },
    ISLAND_PREVIEW_TITLE_DESCRIPTION_VERTICAL: {
        size: 60,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE,
        shadow: cleverapps.styles.DECORATORS.IMAGE_FONT_SHADOW
    }
});
